<script>
  import {onMount} from "svelte";
  import OrbitingPlanet from "./Elements/OrbitingPlanet.svelte";
  import Sun from "./Elements/Sun.svelte";
  import {labels, mainTimeline} from "../timelines/main-timeline";
  import gsap from "gsap";

  
  const startPosition = {x: 800, y: 450};
  const planets = Array.from(new Array(6));

  const {planetsStart, planetsEnd} = labels;
  const planetTimeline = gsap.timeline();
  const outTimeline = gsap.timeline();

  let glow;

  onMount(() => {

      planets.forEach((planet, i) => {
        gsap.set('.planetScale-' + i, {
            scale: (i + 1) * 0.6 + 0.8,
            transformOrigin: 'center',
        })
      });

      planetTimeline.from('.orbiter', {
          opacity: 0,
          scale: 0,
          duration: 1,
          stagger: -0.05,
          transformOrigin: "50% 50%",
          ease: 'BounceOut',
      }, 0)
          .from('.sun', {
              scale: 0,
              duration: 1,
              opacity: 0.2,
              ease: 'out',
              transformOrigin: "50% 50%",
          }, '<')
          .to('.sun', {
              scale: 0.95,
              duration: 0.15,
              ease: 'in-out',
              transformOrigin: "50% 50%",
          });

      outTimeline.to('.the-planets', {
          scale: 2,
          opacity: 0,
          transformOrigin: "50% 50%",
          duration: 0.3,
      });

      mainTimeline.add(planetTimeline, planetsStart);
      mainTimeline.add(outTimeline, planetsEnd);
  });

</script>

<g class="the-planets">
    {#each planets as planet, i}
            <g class={"planet planetScale-" + i}>
                <g class="orbiter">
                <OrbitingPlanet planetScale={Math.random() * 0.2 + 0.4} orbitalPeriod={i}/>
                </g>
            </g>
    {/each}
    <g class="sun">
        <Sun />
    </g>
</g>

<style>

    .the-planets {
        transform: translateY(450px);
    }

    .planet {
        transform-origin: 950px 50px;
    }

    .sun {
        transform: translate(750px, -130px);
        opacity: 0.6;
    }
</style>